import type { DeprecatedModalTokens } from './types';

export const deprecatedModal: DeprecatedModalTokens = {
  colors: {
    background: 'rgba(39, 39, 39, 0.6)',
  },
};
